<template>
    <div class="dashboard-chart-card mr-1">
        <div class="d-flex justify-content-center mb-3 mt-3 pt-3 pb-3" v-if="is_load">
            <b-spinner variant="success" label="Loading..."></b-spinner>
        </div>

        <div class="chart" v-else>
            <highcharts :options="chartOptions" :highcharts="char3d"></highcharts>
        </div>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts3D from 'highcharts/highcharts-3d'
    import Highcharts from 'highcharts'

    Highcharts3D(Highcharts)
    export default {
        name: "cur_load",

        props: {
            id: {
                type: Number,
                require: true,
            },

            month: {
                type: String,
                default: ""
            },

        },

        components: {
            highcharts: Chart
        },

        created() {
            EventBus.$on('change_date', res => {
                this.getStat();
            });
        },
        mounted() {
            this.getStat();
        },

        data() {
            return {
                is_load: true,
                char3d: Highcharts,
                chartOptions: {

                    chart: {
                        type: 'spline',
                        scrollablePlotArea: {
                            minWidth: 600,
                            scrollPositionX: 1
                        },
                        options3d: {
                            enabled: true,
                            alpha: 0,
                            beta: 20,
                            depth: 80
                        }
                    },
                    yAxis: {
                        title: {
                            text: ' '
                        },
                        gridLineColor: '#f1f2f7'
                    },

                    plotOptions: {
                        spline: {
                            lineWidth: 3,
                            states: {
                                hover: {
                                    lineWidth: 4
                                }
                            },
                            marker: {
                                enabled: false
                            },
                            pointInterval: 3600000, // one hour
                            pointStart: this.dash_param_date
                        }
                    },
                    xAxis: {
                        type: 'datetime',
                        lineColor: '#eef0f5',
                        labels: {
                            overflow: 'justify'
                        }
                    },

                    title:
                        {
                            text: this.__t('LOAD_HOUR'),
                            align: 'left',
                            style:
                                {
                                    color: '#3b3f5c',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                }
                            //x: -20 //center
                        },
                    series: [{
                        colorByPoint: false,
                        showInLegend: false,
                        name: '$ ',
                        data: []
                    }],
                    credits: {
                        enabled: false
                    },
                },

            }
        },


        methods: {
            async getStat() {
                this.is_load = true;

                await api.post('/internal/user/dashboard/load', qs.stringify({
                        'date': this.dash_param_date,
                    })
                ).then(({data}) => {
                    if (data.status == "operation_success") {


                        this.chartOptions.plotOptions.spline.pointStart = data.data.start;
                        this.chartOptions.plotOptions.spline.pointInterval = data.data.interval;

                        this.chartOptions.series = data.data.series;

                        this.is_load = false;
                    } else {

                    }

                }).catch(err => {
                    this.is_load = true;
                    console.log(err);
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            },

        },
        computed: {
            dash_param_date() {
                return this.$store.state.dashboard.main.date;
            },

        },

    }
</script>

<style scoped>

</style>
